import ReactToPrint from 'react-to-print';
import React, { FC, useRef, ReactNode, useState, useEffect, useCallback } from 'react';
import { Grid, MenuItem } from '@material-ui/core';
import { ComponentToPrint } from './ComponentToPrint';
import { useStyles } from './styles';
import { trackAmplitudeData } from '../../services/amplitudeService';
import { PrintIcon } from '../CustomIcons';

interface Props {
  title: string;
  children: ReactNode;
  columnNumber: number;
  translation: any;
  reportNameInEn: string;
}

export const PrintButton: FC<Props> = ({ title, children, columnNumber, translation, reportNameInEn }) => {
  const classes = useStyles();
  const componentRef = useRef(null);
  const [pageSize, setPageSize] = useState<string>('portrait');

  useEffect(() => {
    setPageSize(columnNumber > 5 ? 'landscape' : 'portrait');
  }, [columnNumber]);

  const trackPrinting = useCallback(() => {
    trackAmplitudeData('partnerPortal_action_report', {
      type: 'Print',
      report_name: reportNameInEn,
    });
  }, [reportNameInEn]);

  return (
    <Grid item>
      <ReactToPrint
        trigger={() => (
          <MenuItem className={classes.printButton}>
            <PrintIcon />
            <span className={classes.printBtnText}>{translation.text_6413}</span>
          </MenuItem>
        )}
        onBeforePrint={trackPrinting}
        content={() => componentRef.current}
        pageStyle={`
            @page { 
                size: ${pageSize}; 
            }
        
            @media all {
                .pagebreak {
                    display: none;
                }
            }

            @media print {
                .pagebreak {
                    page-break-before: always;
                }
            }
        `}
      />
      <ComponentToPrint ref={componentRef} title={title} columnNumber={columnNumber}>
        {children}
      </ComponentToPrint>
    </Grid>
  );
};
